'use client'
import { type FC, type ReactNode } from 'react'
import { Text } from '@chakra-ui/react'

interface CheckoutSectionHeadingProps {
  children: ReactNode
}

/**
 * Title for a section of the checkout steps — "Recipient details", "Delivery options",
 * "Billing address" and the like.
 *
 * These sit directly beneath one another in the same column, often from different
 * components (a carrier widget, then our own address picker), so they have to look
 * identical. They deliberately do not use `GrandHeading`: that carries the theme's
 * heading typeface and weight, which reads as a page title rather than a field-group
 * label and made the billing section stand out from the carrier widgets next to it.
 */
export const CheckoutSectionHeading: FC<CheckoutSectionHeadingProps> = ({ children }) => (
  <Text fontSize="xl" fontWeight="bold">
    {children}
  </Text>
)
